


export const allQuestions = [
    {
        question: "How are you feeling emotionally right now?",
        options: ['Happy 😊', 'Sad 😔', 'Anxious 😰', 'Hopeful 🌈', 'Angry 😠']
    },
    // {
    //     question: "What’s one thing that made you smile recently?",
    //     options: [  ]
    // },
    {
        question: "Have you felt anxious or stressed today?",
        options: [ 'yes', 'no' ]

    },
    {
        question: "How did you sleep last night?",
        options: [ 'okay', 'great', 'good' ]

    },
    {
        question: "How’s your energy level today?",
        options: [ '1', '3', '5', '7', '10' ]
    },
    {
        question: "Are you feeling connected to others?",
        options: [ 'no', 'yes' ]
        
    },
    {
        question: "Have you taken a break for yourself today?",
        options: [ 'no', 'yes' ]
        
    },
    {
        question: "Is anything worrying you right now?",
        options: [ 'no', 'yes' ]
    },
    {
        question: "Have you moved your body today?",
        options: [ 'walk', 'stretch', 'no' ]
    },
    {
        question: "Are you feeling hopeful about the future?",
        options: [ 'yes', 'no' ]
        
    },
    // {
    //     question: "Have you been kind to yourself today?",
    //     options: [ 'yes', 'no' ]
    // },
    {
        question: "Do you feel productive today?",
        options: [ 'yes', 'no' ]
    },
    {
        question: "Have you eaten something nourishing today?",
        options: [ 'yes', 'no' ]
        
    },
    {
        question: "Is your mind feeling calm or overwhelmed?",
        options: [ 'calm', 'overwhelmed' ]
    },
    {
        question: "Have you had a moment of joy today?",
        options: [ 'no', 'yes' ]
    },
    {
        question: "Do you feel safe and secure today?",
        options: [ 'no', 'yes' ]
    },
    {
        question: "How stressed do you feel right now?",
        options: [ '1', '3', '5', '7', '10' ]
    },
    {
        question: "How focused or clear-minded are you today?",
        options: [ '10%', '50%', '100%' ]
    },
  ];
  